import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export interface ToolbarSwitcherProps {
	hasSelection: boolean;
	filterComponent: ReactNode;
	actionComponent: ReactNode;
	className?: string;
}

export function ToolbarSwitcher({
	hasSelection,
	filterComponent,
	actionComponent,
	className,
}: ToolbarSwitcherProps) {
	return (
		<div className={cn("relative mb-2 grid items-center", className)}>
			{/* Filters */}
			<div
				className={cn(
					"col-start-1 row-start-1 transition-all duration-200",
					hasSelection
						? "invisible pointer-events-none -translate-y-1 opacity-0"
						: "visible translate-y-0 opacity-100",
				)}
				aria-hidden={hasSelection}
			>
				{filterComponent}
			</div>

			{/* Actions */}
			<div
				className={cn(
					"col-start-1 row-start-1 transition-all duration-200",
					hasSelection
						? "visible translate-y-0 opacity-100"
						: "invisible pointer-events-none translate-y-1 opacity-0",
				)}
				aria-hidden={!hasSelection}
			>
				{actionComponent}
			</div>
		</div>
	);
}
